export default "__VITE_ASSET__D3siOmvk__"